import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Typography } from 'pvs-design-system';
import { Stack } from '@mui/material';
import ControlPointIcon from '@mui/icons-material/ControlPoint';
import ToolsTable from 'components/ToolsTable/ToolsTable';
import { PAGE_TITLE_HEADER_TEXT_ID, ROUTES } from 'constants/constants';
import bootConfig from 'utils/bootConfig';

const { permissions } = bootConfig.authInfo;

const ToolsManagementPage: React.FC = () => {
  return (
    <>
      <Typography
        id={PAGE_TITLE_HEADER_TEXT_ID}
        variant="h1"
        textAlign="left"
        style={{ padding: '0' }}
      >
        LTI 1.3 Tool Configuration
      </Typography>
      <Stack
        direction="row"
        sx={{
          marginTop: '24px',
          marginBottom: '35px',
          alignItems: 'center',
        }}
      >
        <Stack flex="1" direction="row">
          <Button
            id="addNewTool"
            startIcon={<ControlPointIcon />}
            sx={{ marginLeft: 'auto' }}
            component={Link}
            to={ROUTES.createTool}
            disabled={!permissions.canManagePlatform}
          >
            Add New LTI 1.3 Tool
          </Button>
        </Stack>
      </Stack>
      <ToolsTable />
    </>
  );
};

export default ToolsManagementPage;
